var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-10/12 sm:w-80 h-96 mx-auto bg-white rounded-md overflow-hidden shadow-sm"},[_c('img',{staticClass:"w-full h-1/2 object-cover",attrs:{"src":_vm.getImage(this.image),"alt":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }